import { useQuery } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import { queryKeys } from "../../query-keys";

const COUNTS_REFRESH_MS = 60_000;

/** Sidebar totals; the caller enables requests once a session is available. */
export function usePlatformCounts(enabled: boolean) {
	return useQuery({
		enabled,
		queryFn: () => adminApi.platformStats.counts(),
		queryKey: queryKeys.platformCounts.all,
		refetchInterval: COUNTS_REFRESH_MS,
		refetchIntervalInBackground: false,
		staleTime: COUNTS_REFRESH_MS,
	});
}

/** Admin dashboard overview: lifetime totals + daily growth series over `days`. */
export function usePlatformStats(days: number) {
	return useQuery({
		queryFn: () => adminApi.platformStats.get(days),
		queryKey: queryKeys.platformStats.range(days),
	});
}
